angular.module('core')
    .service('activityApi', ['cancelableResourceFactory', 'cancelableResourceManager', '$state', 'customer', 'transformResponse', 'moment', 'exportService', 'configuration', 'dblActivityFactoryService', 'timeframe',
        function ($cancelableResourceFactory, $cancelableResourceManager, $state, $customer, $transformResponse, $moment, $exportService, $configuration, dblActivityFactoryService, dblTimeframe) {

    var self = this;

    // TODO: move this mapping to Activity class in dbl-activity-factory.service.js or even to the backend.
    var mapLabels = function(code) {
        var label;

        switch (code) {
            case 100:
                label = "Lesson Opened";
                break;
            case 701:
                label = "Standard";
                break;
            case 120:
                label = "Lesson In Progress";
                break;
            case 110:
                label = "Lesson Complete";
                break;
            case 130:
                label = "Lesson Group Complete";
                break;
            case 703:
                label = "Lesson Group Complete";
                break;
            case 200:
                label = "Certificate Awarded";
                break;
            case 210:
                label = "Adventure Friend Awarded";
                break;
            case 220:
                label = "Graduation";
                break;
            case 300:
                label = "Badge Earned";
                break;
            case 400:
                label = "Enter Reassessment";
                break;
            case 500:
                label = "Feedback";
                break;
            default:
                label = "Activity";
          }

        return label;
    };

    var activitiesMapping = function(event) {
        // TODO: move this mapping to Activity class in dbl-activity-factory.service.js after all customers
        // are converted to new activity feed.
        event.standards = ($customer.getAcademicStandard().academic_standard_name === 'dbl') ? _.take(event.standards, 1) : _.take(event.standards, 5);
        event.label = mapLabels(event.event_code);
        event.lessonComplete = event.event_code === 110;
        event.groupComplete = (event.event_code === 130 || event.event_code === 703);
        // Continue to use the demo lesson until the back end for the actual lesson is ready.
        event.lesson_slot_name = event.lesson_slot_name ? event.lesson_slot_name : event.demo_lesson_name;
        event.demoLessonSlotName = event.groupComplete ? event.demo_lesson_name : event.lesson_slot_name;
        // add dbl_standard.name to make de-dupping easier
        event.lessonGroupName = event.dbl_standard ? event.dbl_standard.name : null;
    };

    var createActivityObjects = function (data) {
        // create activity objects from the raw data
        data.activities = _.map(data.events, function (event) {
            return dblActivityFactoryService.create(event);
        });

        return data;
    };

    var StudentEvents = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/students/:studentId/activity', { }, {
        query: {
            url: '/r/districts/:districtId/students/:studentId/activity',
            method: 'GET',
            transformResponse: function(body, headersGetter, status) {
                return $transformResponse.transformActivitiesQuery('event', body, activitiesMapping, status);
            }
        }
    });

    var engagementActivitiesMapping = function(event) {
    };

    var StudentEngagementEvents = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/students/:studentId/engagement/activity', { }, {
        query: {
            url: '/r/districts/:districtId/students/:studentId/engagement/activity',
            method: 'GET',
            transformResponse: function(body, headersGetter, status) {
                return $transformResponse.transformActivitiesQuery('event', body, engagementActivitiesMapping, status);
            }
        }
    });

    var classroomEventsUrl = '/r/districts/:districtId/classrooms/:classroomId/activity';
    var ClassroomEvents = $cancelableResourceFactory.createCacheableResource(null, classroomEventsUrl, { }, {
        query: {
            url: classroomEventsUrl,
            method: 'GET',
            transformResponse: function(body, headersGetter, status) {
                return $transformResponse.transformActivitiesQuery('event', body, activitiesMapping, status);
            }
        }
    });

    var iaplClassroomEventsUrl = '/r/districts/:districtId/classrooms/:classroomId/activity/lessongroup';
    var iaplClassroomEvents = $cancelableResourceFactory.createCacheableResource('iapl', iaplClassroomEventsUrl, { }, {
        query: {
            url: iaplClassroomEventsUrl,
            cache: true,
            method: 'GET',
            transformResponse: function(body, headersGetter, status) {
                return $transformResponse.transformActivitiesQuery('event', body, activitiesMapping, status);
            }
        }
    });

    var iaplStudentEventsUrl = '/r/districts/:districtId/students/:studentId/activity/lessongroup';
    var iaplStudentEvents = $cancelableResourceFactory.createCacheableResource('iapl', iaplStudentEventsUrl, { }, {
        query: {
            url: iaplStudentEventsUrl,
            cache: true,
            method: 'GET',
            transformResponse: function(body, headersGetter, status) {
                return $transformResponse.transformActivitiesQuery('event', body, activitiesMapping, status);
            }
        }
    });

    var getClassroomActivitiesParams = function() {
        var params = _.pick($state.params, ['districtId', 'classroomId']);

        // @TODO update api so we get today's events by default
        // (currently api returns only up to beginning of the current day)
        params.td = $moment().add(1, 'days').format('YYYYMMDD');
        // End @TODO
        // get activities for last 30 days
        params.days = "30";
        return params;
    };

    self.getClassroomActivitiesExportUrl = function(callback) {
        var params = getClassroomActivitiesParams();
        return $exportService.buildExportUrl(classroomEventsUrl, params);
    };

    self.getClassroomActivities = function() {
        var params = getClassroomActivitiesParams();
        var next_page = $state.current.data.next_page;
        if (next_page) {
            params.pu = next_page.pu;
            params.pt = next_page.pt;
            params.pd = next_page.pd;
        }
        var promises = ClassroomEvents.query(params);
        $cancelableResourceManager.addAndRemoveOnFinish(promises);
        return promises.$promise.then(createActivityObjects);
    };

    self.getIaplActivities = function (level, sy, days, fd, td, callback) {
        var params = _.pick($state.params, ['districtId', 'classroomId', 'studentId']);
        params.days = days;
        params.sy = sy;
        params.fd = fd;
        params.td = td;

        if (level === 'student') {
          delete params.classroomId;
        }
        var promises = (level === 'student' ?  iaplStudentEvents.query(params) : iaplClassroomEvents.query(params));

        promises.$promise.then(callback);
        return promises;
    };

    self.getStudentEngagementActivity = function(districtId, studentId) {
        var days = dblTimeframe.parseNumber('day');
        days = isFinite(days) ? days : undefined;
        var sy = dblTimeframe.parseNumber('year');
        sy = isFinite(sy) ? sy : undefined;
        var fd = dblTimeframe.getFromDate();
        var td = dblTimeframe.getToDate();

        var params = {
            districtId: districtId,
            studentId: studentId,
            sy: sy,
            days: days,
            fd: fd,
            td: td
        };

        var resource = StudentEngagementEvents.query(params);
        $cancelableResourceManager.addAndRemoveOnFinish(resource);

        return resource.$promise;
    };

    self.getStudentActivitiesForGuardian = function(days, fd, td, getAllActivities) {
        // http://edex.dreambox.net:8380/r/districts/-1/students/19681/activity?ast=dbl&td=20151028
        var params = [];
        params.districtId = $state.params.studentDistrictId;
        params.studentId = $state.params.studentId;
        var next_page = $state.current.data.next_page;
        if (next_page) {
            params.pu = next_page.pu;
            params.pt = next_page.pt;
            params.pd = next_page.pd;
        }
        params.untilNow = true;
        if (getAllActivities) { params.ps = '10000'; }

        // @TODO update api so we get today's events by default
        // (currently api returns only up to beginning of the current day)
        params.td = $moment().add(1, 'days').format('YYYYMMDD');
        // End @TODO
        params.days = days !== undefined ? days : '30';

        if (fd !== undefined) { params.fd = fd; }
        if (td !== undefined) { params.td = td; }

        var resource = StudentEvents.query(params);
        $cancelableResourceManager.addAndRemoveOnFinish(resource);

        return resource.$promise.then(createActivityObjects);
    };

    self.getStudentActivities = function(districtId, studentId, days, fd, td, getAllActivities, nextPage) {
        var params = {
            studentId: studentId,
            districtId: districtId
        };

        if (nextPage) {
            params.pu = nextPage.pu;
            params.pt = nextPage.pt;
            params.pd = nextPage.pd;
        }

        if (getAllActivities) {
            params.ps = '10000';
        }

        // @TODO update api so we get today's events by default
        // (currently api returns only up to beginning of the current day)
        params.td = $moment().add(1, 'days').format('YYYYMMDD');
        // End @TODO
        params.days = days !== undefined ? days : '30';

        if (fd !== undefined) { params.fd = fd; }
        if (td !== undefined) { params.td = td; }

        var promises = StudentEvents.query(params);
        $cancelableResourceManager.addAndRemoveOnFinish(promises);

        return promises.$promise.then(createActivityObjects);
    };
}]);
